<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import { initSocket } from '@/libs/socket'
  import { getCookies } from './libs/utils';
  export default {
    data() {
      return { }
    },
    mounted() {
      this.pollTime()

      if( localStorage.getItem('chat_token') ) {
        // initSocket('', { type: 'kefu_login', data: localStorage.getItem('chat_token') })
      }
    },
    methods: {
      pollTime() {
        // 20分钟后执行（20分钟 = 20 * 60 * 1000 毫秒）
        setTimeout(() => {
          location.reload()
        }, 20 * 60 * 1000)

      }
    }
  }
</script>

<style>
  * {
    margin: 0;
    padding: 0;
  }
</style>
